/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcrossposttitle3Inputs */

const en_crosspostingcrossposttitle3 = /** @type {(inputs: Crosspostingcrossposttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post everywhere`)
};

const de_crosspostingcrossposttitle3 = /** @type {(inputs: Crosspostingcrossposttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überall posten`)
};

/**
* | output |
* | --- |
* | "Post everywhere" |
*
* @param {Crosspostingcrossposttitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcrossposttitle3 = /** @type {((inputs?: Crosspostingcrossposttitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcrossposttitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcrossposttitle3(inputs)
	return de_crosspostingcrossposttitle3(inputs)
});
export { crosspostingcrossposttitle3 as "crosspostingCrossPostTitle" }